import React, { Component, PropTypes } from 'react';

const BASKETBALL_SVG_SOURCE = require('../../res/basketball.svg');

export default class BasketballIcon extends Component {
  static propTypes = {
    size: PropTypes.number
  };

  static defaultProps = {
    size: 12
  };

  render() {
    const { className, size } = this.props;
    const style = { height: size, width: size };

    return (
      <img className={className} src={BASKETBALL_SVG_SOURCE} style={style}/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/BasketballIcon.jsx